function listenerSliderSlideButtonClick (e) {
  const scrollLeftBy = e.target.dataset.scroll_left_by
  const slider = this.getSliderFromButton(e.target)
  if (null === slider) {
    return
  }
  this.slideNativeSliderBy(slider, scrollLeftBy)
  this.dispatchNativeSliderPostUpdate(slider, this.data.events.nativeSliderPostUpdate.options.causes.button, e)
}

function getAxisAccessors (axis) {
  const accessors = {
    offset: 'offsetTop',
    page: 'pageY',
    scroll: 'scrollTop'
  }
  if ('x' === axis) {
    accessors.offset = 'offsetLeft'
    accessors.page = 'pageX'
    accessors.scroll = 'scrollLeft'
  }
  return accessors
}

function listenerSliderXYDragMousedown (nativeSlider, e) {
  const dragData = this.data.dragDataLayer.get(nativeSlider)
  const accessors = getAxisAccessors(dragData.scrollMode)
  dragData.isDown = true
  nativeSlider.classList.add(this.data.classList.draggable)
  dragData.startXY = e[accessors.page] - nativeSlider[accessors.offset]
  dragData.scrollLeftTop = nativeSlider[accessors.scroll]
  this.dispatchNativeSliderPostUpdate(
    nativeSlider,
    this.data.events.nativeSliderPostUpdate.options.causes.mousedown,
    e
  )
  this.data.dragDataLayer.set(nativeSlider, dragData)
}

function listenerSliderXYDragMouseleave (nativeSlider, e) {
  const dragData = this.data.dragDataLayer.get(nativeSlider)
  dragData.isDown = false
  nativeSlider.classList.remove(this.data.classList.draggable)
  this.dispatchNativeSliderPostUpdate(
    nativeSlider,
    this.data.events.nativeSliderPostUpdate.options.causes.mouseleave,
    e
  )
  this.data.dragDataLayer.set(nativeSlider, dragData)
}

function listenerSliderXYDragMouseup (nativeSlider, e) {
  const dragData = this.data.dragDataLayer.get(nativeSlider)
  dragData.isDown = false
  nativeSlider.classList.remove(this.data.classList.draggable)
  this.dispatchNativeSliderPostUpdate(
    nativeSlider,
    this.data.events.nativeSliderPostUpdate.options.causes.mouseup,
    e
  )
  this.data.dragDataLayer.set(nativeSlider, dragData)
}

function listenerSliderXYDragMousemove (nativeSlider, e) {
  const dragData = this.data.dragDataLayer.get(nativeSlider)
  if (!dragData.isDown) {
    return
  }
  const accessors = getAxisAccessors(dragData.scrollMode)
  e.preventDefault()
  const xy = e[accessors.page] - nativeSlider[accessors.offset]
  const walk = (xy - dragData.startXY) * (1 * nativeSlider.dataset.drag_speed)
  nativeSlider[accessors.scroll] = dragData.scrollLeftTop - walk
  this.dispatchNativeSliderPostUpdate(
    nativeSlider,
    this.data.events.nativeSliderPostUpdate.options.causes.mousemove,
    e
  )
}

export default class NativeSlider {
  constructor (options = {}) {
    this.data = {
      pollingInterval: 1000,
      deltaPadding: 0.1,
      diffThreshold: 1,
      renderLoopTimingBelt: null,
      renderQueue: null,
      classList: {
        draggable: 'native_slider-dragged',
        listGroup: 'native_slider-lg',
        listItem: 'native_slider-li',
        button: 'native_slider-btn',
        buttonNext: 'native_slider-btn-next',
        buttonPrev: 'native_slider-btn-prev'
      },
      events: {
        nativeSliderRenderLoopPreUpdate: {
          handle: 'nativeSliderRenderLoopPreUpdate',
          enabled: true
        },
        nativeSliderPostUpdate: {
          enabled: false,
          handle: 'nativeSliderPostUpdate',
          options: {
            causes: {
              renderLoopAnimationUpdate: 'renderLoopAnimationUpdate',
              renderLoopUpdate: 'renderLoopUpdate',
              mouseleave: 'mouseleave',
              mousemove: 'mousemove',
              mousedown: 'mousedown',
              mouseup: 'mouseup',
              button: 'button'
            }
          }
        }
      },
      dragDataLayer: null
    }
  }

  getSliderFromButton (button) {
    return button.parentNode.getElementsByClassName(this.data.classList.listGroup)[0] || null
  }

  slideNativeSliderCommand (slider, { direction }) {
    const scrollPosition = slider.scrollWidth - slider.clientWidth
    const scrollPositionLeft = scrollPosition - slider.scrollLeft
    const scrollPositionRight = scrollPosition - scrollPositionLeft
    const hasReachedLimit = (1 === direction)
      ? scrollPositionLeft < this.data.diffThreshold
      : scrollPositionRight < this.data.diffThreshold
    direction *= hasReachedLimit ? -1 : 1
    this.slideNativeSliderBy(slider, direction)
    return { direction }
  }

  slideNativeSliderBy (slider, scrollLeftBy) {
    const firstChildWidth = slider.children[0].getBoundingClientRect().width
    const directionLeft = firstChildWidth * scrollLeftBy
    slider.scrollBy({
      top: 0,
      left: directionLeft,
      behavior: 'smooth'
    })
  }

  update ({ renderQueue }) {
    for (const renderQueueEntry of renderQueue) {
      this.dispatchNativeSliderPostUpdate(
        renderQueueEntry.el,
        this.data.events.nativeSliderPostUpdate.options.causes.renderLoopUpdate,
        renderQueueEntry
      )
      const nextUpdateTS = renderQueueEntry.lastUpdated + renderQueueEntry.interval
      const dateDiff = nextUpdateTS - Date.now()
      if (dateDiff > 0) {
        continue
      }
      window.requestAnimationFrame((domTS) => {
        renderQueueEntry.command.data = this[renderQueueEntry.command.handle](
          renderQueueEntry.el,
          renderQueueEntry.command.data
        )
        this.dispatchNativeSliderPostUpdate(
          renderQueueEntry.el,
          this.data.events.nativeSliderPostUpdate.options.causes.renderLoopAnimationUpdate,
          renderQueueEntry
        )
        renderQueueEntry.lastUpdated = Date.now()
      })
    }
  }

  dispatchNativeSliderPostUpdate (slider, cause, payload) {
    if (false === this.data.events.nativeSliderPostUpdate.enabled) {
      return
    }
    slider.dispatchEvent(new CustomEvent(this.data.events.nativeSliderPostUpdate.handle, {
      detail: { slider, cause, payload, nativeSliderInstance: this }
    }))
  }

  dispatchNativeSliderRenderLoopPreUpdate () {
    if (false === this.data.events.nativeSliderRenderLoopPreUpdate.enabled) {
      return
    }
    document.dispatchEvent(new CustomEvent(this.data.events.nativeSliderRenderLoopPreUpdate.handle, {
      detail: {
        renderQueue: this.data.renderQueue,
        nativeSliderInstance: this
      }
    }))
  }

  createNewRenderQueueEntry (el, commandHandle, commandData, interval) {
    return {
      el,
      interval,
      lastUpdated: Date.now(),
      command: {
        handle: commandHandle,
        data: commandData
      }
    }
  }

  initButtons (target = null) {
    if (null === target) {
      target = document
    }
    const nativeSliderButtons = target.getElementsByClassName(this.data.classList.button)
    for (const nativeSliderButton of nativeSliderButtons) {
      const slider = this.getSliderFromButton(nativeSliderButton)
      if (!slider) {
        continue;
      }
      const overFlowingDiff = Math.abs(slider.clientWidth - slider.scrollWidth) + this.data.deltaPadding
      const isSliderOverFlowing = overFlowingDiff > this.data.diffThreshold
      const alwaysShow = '1' === nativeSliderButton.dataset.always_show
      if (!isSliderOverFlowing && !alwaysShow) {
        nativeSliderButton.style.display = 'none'
        continue
      }
      nativeSliderButton.removeEventListener(
        'click', listenerSliderSlideButtonClick.bind(this)
      )
      nativeSliderButton.addEventListener(
        'click',
        listenerSliderSlideButtonClick.bind(this),
        { passive: true }
      )
    }
  }

  initSliders (target = null) {
    if (null === target) {
      target = document
    }
    const nativeSliders = target.getElementsByClassName(this.data.classList.listGroup)
    for (const nativeSlider of nativeSliders) {
      if ('autoplay_interval' in nativeSlider.dataset) {
        const autoplayInterval = nativeSlider.dataset.autoplay_interval * 1
        const renderQueueEntry = this.createNewRenderQueueEntry(
          nativeSlider,
          'slideNativeSliderCommand',
          { direction: 1 },
          autoplayInterval
        )
        this.data.renderQueue.add(renderQueueEntry)
      }
      if ('drag_speed' in nativeSlider.dataset) {
        const computedSliderStyle = window.getComputedStyle(nativeSlider)
        const scrollMode = computedSliderStyle.scrollSnapType.startsWith('y') ? 'y' : 'x'
        this.data.dragDataLayer.set(nativeSlider, {
          isDown: false,
          startXY: 0,
          scrollLeftTop: 0,
          scrollMode
        })
        const eventMap = {
          mousedown: listenerSliderXYDragMousedown,
          mouseleave: listenerSliderXYDragMouseleave,
          mouseup: listenerSliderXYDragMouseup,
          mousemove: listenerSliderXYDragMousemove
        }
        for (const [event, listener] of Object.entries(eventMap)) {
          nativeSlider.removeEventListener(event, listener.bind(this, nativeSlider))
          nativeSlider.addEventListener(event, listener.bind(this, nativeSlider))
        }
      }
    }
  }

  initRenderLoop () {
    this.data.renderLoopTimingBelt = null
    document.addEventListener('nativeSliderRenderLoopPreUpdate', (e) => {
      clearInterval(this.data.renderLoopTimingBelt)
      this.update(e.detail)
      this.data.renderLoopTimingBelt = setInterval((e) => {
        this.dispatchNativeSliderRenderLoopPreUpdate()
      }, this.data.pollingInterval)
    })
    this.dispatchNativeSliderRenderLoopPreUpdate()
  }

  initSlidersWithButtons (target = null) {
    if (null === target) {
      target = document
    }
    this.initButtons(target)
    this.initSliders(target)
  }

  init () {
    if (null === this.data.renderQueue) {
      this.data.renderQueue = new Set()
    }
    if (null === this.data.dragDataLayer) {
      this.data.dragDataLayer = new Map()
    }
    this.initSlidersWithButtons()
    this.initRenderLoop()
  }
}
